import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { Alert, Box, Button, Stack, TextField } from '@mui/material'
import { useAuth } from '~/api/auth'
import { Title } from '~/components'
import { showToast } from '~/utils'

const ResetPassword = () => {
  const params = useParams()
  const [searchParams] = useSearchParams()
  const { resetPassword } = useAuth({
    middleware: 'guest',
    // redirectIfAuthenticated: '/',
  })
  const { t } = useTranslation()
  const [email, setEmail] = useState(searchParams.get('email'))
  const [errorMessage, setErrorMessage] = useState()

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault()
      const data = Object.fromEntries(new FormData(e.target).entries())
      const result = await resetPassword({
        setErrorMessage,
        ...data,
      })
      if (result) {
        showToast(t('auth.reset.success'), { variant: 'success' })
      }
    },
    [resetPassword, t]
  )

  return (
    <div className="flex justify-center items-center">
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{ maxWidth: '400px', width: '100%' }}
        onSubmit={onSubmit}
      >
        <Stack spacing={4}>
          <Title>{t('auth.reset.title')}</Title>
          <Stack spacing={2}>
            <TextField
              label={t('auth.email')}
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              autoComplete="new-password"
              label={t('auth.password')}
              name="password"
              type="password"
            />
            <TextField
              label={t('auth.password-confirmation')}
              name="password_confirmation"
              type="password"
            />
            <input name="token" type="hidden" value={params.token} />
            <Button variant="contained" type="submit">
              {t('auth.reset.cta')}
            </Button>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
          </Stack>
        </Stack>
      </Box>
    </div>
  )
}

export default ResetPassword
